import React, { SyntheticEvent, useState } from "react";
import { Autocomplete, AutocompletePropsSizeOverrides, MenuItem, Select, TextField } from "@mui/material";
import { OverridableStringUnion } from "@mui/types";
import { useTranslation } from "react-i18next";


interface TwoFactorAuthAutocompleteProps {
  /**
   * The currently selected 2fa method.
   */
  method?: string;
  /**
   * Callback fired when the 2fa method is changed.
   */
  onChange(method: string): void;
  
  /**
   * The size of the component.
   * @default 'medium'
   */
  size?: OverridableStringUnion<'small' | 'medium', AutocompletePropsSizeOverrides>;
}

// eslint-disable-next-line react/display-name
export default function(props: TwoFactorAuthAutocompleteProps): React.JSX.Element {
  const {i18n} = useTranslation();

  const [selectedMethod, setSelectedMethod] = useState<string>(props.method || "none");

  function handleMethodChange(method: string): void {
    setSelectedMethod(method);
    props.onChange(method);
  }

  return (
      <Select
        value={selectedMethod}
        onChange={(event) => handleMethodChange(event.target.value)}>
        <MenuItem value={"email"}>{i18n.t("login.form.email")}</MenuItem>
        <MenuItem value={"none"}>{i18n.t("disabled")}</MenuItem>
      </Select>
    )
}